import { render, staticRenderFns } from "./UpiHome.vue?vue&type=template&id=0924ca5e&scoped=true&"
import script from "./UpiHome.vue?vue&type=script&lang=js&"
export * from "./UpiHome.vue?vue&type=script&lang=js&"
import style0 from "./UpiHome.vue?vue&type=style&index=0&id=0924ca5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924ca5e",
  null
  
)

export default component.exports